import Axios from "axios";
import { eventBus } from "@/main";

export const URL = "https://iraquss.com/api.php";
export const IMAGEURL = "https://iraquss.com/";
export const UploadHeader = {
  headers: { "Content-Type": "multipart/form-data" }
};
export const FormHeader = {
  headers: { "Content-Type": "application/x-www-form-urlencoded" }
};
export function __HTTP($endPoint, $body, $headers, $callBack) {
  if ($headers == null) $headers = FormHeader;

  if (process.env.NODE_ENV == "production") {
    //$body.isAdmin = true;
    
  } else {
    $endPoint = $endPoint+"&debug=true";
  }

  Axios.post(URL + $endPoint, $body, $headers).then(res => {
    if (res.status == 200) {
      if (typeof res.data.logout !== "undefined") {
        if (res.data.logout == true) {
          eventBus.$emit("logout");
        }
      }
      $callBack(res.data);
    } else {
      alert("");
    }
  });
}
export function _numFormat($num) {
  //$num 
  var v = $num.toLocaleString('en-US');
  //console.log(v);
  return v;
  
}

export function __HAS_PERM($permid, $uid, cb) {
  __HTTP(
    "?do=checkperms",
    JSON.stringify({ pid: $permid, id: $uid }),
    null,
    res => {
      if (res.auth == true) {
        cb(true);
      } else {
        alert("لا تمتلك صلاحية");
      }
    }
  );
}
export function __HAS_INLINE_PERM($permid, $uid, cb) {
  __HTTP(
    "?do=checkperms",
    JSON.stringify({ pid: $permid, id: $uid }),
    null,
    res => {
      if (res.auth == true) {
        cb(true);
      } else {
        console.log("You don't have this permission:", $permid)
      }
    }
  );
}

